import preval from 'preval.macro';

const BUILD_STAMP = preval`module.exports = new Date().toISOString().slice(0, -5).replace(/T|-|:/gi, '');`;

const APP_VERSION = `${process.env.REACT_APP_VERSION}-${BUILD_STAMP}`;

export default APP_VERSION;
